/**
 * Role-dependent assistant copy. Staff (super admin) strings are the
 * original platform-ops wording and must not drift (regression-tested in
 * copy.test.ts); bank admins get org-scoped wording because the agent
 * restricts their data to their organization's brands.
 */
export interface AssistantCopy {
  emptyTitle: string
  emptySubtitle: string
  pageSubtitle: string
}

const STAFF_COPY: AssistantCopy = {
  emptyTitle: "Ask about platform analytics and operations",
  emptySubtitle:
    "Leads, subscriptions, pricing failures — or admin actions with approval",
  pageSubtitle:
    "Ask about leads, subscriptions, and pricing — admin actions run only after your approval"
}

const BANK_ADMIN_COPY: AssistantCopy = {
  emptyTitle: "Ask about your organization's analytics",
  emptySubtitle:
    "Leads, subscriptions, pricing — admin actions run only after your approval",
  pageSubtitle:
    "Ask about your organization's leads, engagement, and pricing — actions run only after your approval"
}

export const getAssistantCopy = (isSuperAdmin: boolean): AssistantCopy =>
  isSuperAdmin ? STAFF_COPY : BANK_ADMIN_COPY
